import React from 'react';
import { Box, CircularProgress, styled, makeStyles } from '@material-ui/core';

const LoaderEl = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
});

const useStyles = makeStyles((theme) => ({
  progressBackground: {
    color: theme.palette.grey[700],
  },
}));

export default function Loader({ size = 100, minHeight = 500 }) {
  const classes = useStyles();
  return (
    <LoaderEl style={{ minHeight }}>
      <CircularProgress className={classes.progressBackground} size={size} data-testid="progress" />
    </LoaderEl>
  );
}
